/* ============================================================================
   UI / util — the one small helper every component shares.
   Import from "Ui" (index.jsx re-exports every module).
   ============================================================================ */


/* Joins class names, skipping anything that is not a string: cx("a", on && "b"). */
export const cx = (...a) => a.filter(Boolean).join(" ");
